import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable} from 'rxjs';
import { take } from 'rxjs/operators';
import { AgreementShowComponent } from './agreement-show.component';

@Injectable()
export class AgreementShowModalService {

  constructor(
    private modal: BsModalService,
  ) { }

  open():Observable<boolean> {
    const modal:BsModalRef = this.modal.show(AgreementShowComponent, {class:'modal-lg'}); 
    return modal.content.action.pipe(take(1))
  }

}
